<script setup>
import { galleryItems } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec m-sec-dark">
    <h2 class="m-title m-title-dark">道門風範 · 形象實拍</h2>
    <p class="m-sub m-sub-dark">正一天師道法脈傳承，科儀、堪輿、命理一脈相承。</p>
    <div class="m-gallery">
      <figure
        v-for="(g, i) in galleryItems"
        :key="i"
        class="m-gallery-fig"
      >
        <img
          :src="g.image"
          :alt="g.caption"
          class="m-gallery-img"
          loading="lazy"
        />
        <figcaption class="m-gallery-cap">{{ g.caption }}</figcaption>
      </figure>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-sec-dark {
  background: #16241d;
  color: #f7f3ea;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-title-dark {
  color: #f7f3ea;
}

.m-sub {
  text-align: center;
  color: #6f6a5c;
  font-size: 26px;
  margin-top: 18px;
}

.m-sub-dark {
  color: #b9b3a2;
}

.m-gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  margin-top: 44px;
}

.m-gallery-fig {
  margin: 0;
}

.m-gallery-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 14px;
  display: block;
}

.m-gallery-cap {
  margin-top: 10px;
  text-align: center;
  font-size: 22px;
  color: #b9b3a2;
  letter-spacing: 2px;
}
</style>
